module.exports = __webpack_public_path__ + "69dae0b4e8badb8a1fd0719642da245f.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-2004.png
// module id = 518
// module chunks = 0